// This is deprecated. Use bundles/page/lib/appStarterFactory.js
import * as React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router';

import 'js/app/setupEnvironment';

import { setupClient } from 'bundles/page/lib/router';

/**
 * Some apps can't mount on document.body because other libraries like MathJax
 * would get confused. In those cases we can create new child of body to mount on.
 * @param  {String} id id of the div to create (or find)
 * @return {Node}    new child of document.body to mount on, or existing element
 */
function createMountNode(id: $TSFixMe) {
  let mountNode = document.getElementById(id);

  if (!mountNode) {
    mountNode = document.createElement('div');
    mountNode.id = id;
    document.body.appendChild(mountNode);
  }

  return mountNode;
}

/**
 * Run ReactRouter on routes
 */
function runTrackingRouter(routes: $TSFixMe, mountNode: $TSFixMe) {
  return setupClient({ routes }).then((renderProps) => {
    ReactDOM.render(<Router {...renderProps} />, mountNode);
    return renderProps.router;
  });
}

const exported = {
  createMountNode,
  runTrackingRouter,
};

export default exported;
export { createMountNode, runTrackingRouter };
